import { useFrontofficeContext } from "../../context/FrontofficeContext";
import { useLanguageContext } from "../../context/LanguageContext";
import { Themed } from "../../context/ThemeContext";
import { StyledFrontOfficePage } from "./FrontOfficePageStyles";
import { getPage } from "./pages/Pages";
import Screensaver from "./screensaver/Screensaver";
import Settings from "./settings/Settings";

function FrontofficePageView({ onIdleChange, onSettingsOpenChange }) {
  const { pageName, updatePage, terminal } = useFrontofficeContext();
  const { updateLanguage } = useLanguageContext();
  const PageComponent = getPage(pageName);

  return (
    <>
      <Themed frontoffice={true}>
        <StyledFrontOfficePage>
          {terminal && (
            <>
              {PageComponent && <PageComponent />}

              <Screensaver
                screensavers={terminal.screensavers}
                onActivation={(initialActivation) => {
                  onIdleChange(true);
                  updatePage("start");
                  if (terminal.language && !initialActivation) {
                    updateLanguage(terminal.language);
                  }
                }}
                onDeactivation={() => onIdleChange(false)}
              />
            </>
          )}
        </StyledFrontOfficePage>
      </Themed>

      {/* Outside the frontoffice page, so the settings never inherit the theme settings of the client */}
      <Settings onOpenChange={onSettingsOpenChange} />
    </>
  );
}

export default FrontofficePageView;
